import "./kendo.core.js";
import { toCSV, toCSVBlob, getCSVMimeType } from "@progress/kendo-csv";

export const __meta__ = {
    id: "csv",
    name: "CSV generation",
    category: "framework",
    advanced: true,
    mixin: true,
    depends: ["core"]
};

(function($) {

    window.kendo.csv = window.kendo.csv || {};
    window.kendo.csv.toCSV = toCSV;
    window.kendo.csv.toCSVBlob = toCSVBlob;
    window.kendo.csv.getCSVMimeType = getCSVMimeType;

})(window.kendo.jQuery);
